import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import routers from './router';

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
};

const router = new VueRouter(RouterConfig);

export default router;

router.beforeEach((to, from, next) => {
    if (to.path.indexOf('oeetableapp') != -1) {
        next();
    } else {
        // 路由匹配前，可再此做一些检测
        iView.LoadingBar.start();
        // 检测用户是否登陆
        var unlogin = false;
        if (sessionStorage.getItem('user') == null) {
            unlogin = true;
        } else {
            var user = JSON.parse(sessionStorage.getItem('user'));
            if (user.cid == 0) {
                unlogin = true;
            }
        }
        //支配路由
        if (unlogin && to.name !== 'login' && to.name !== 'qrcode') {
            next({
                name: 'login'
            });
        } else if (to.name == 'login' || to.name == 'qrcode') {
            next();
        } else if (new Date().getTime() / 1000 - sessionStorage.getItem('time') > 604800) {
            // 判断localstorage存储是否失效(有效期7天)
            // 已过期，清空数据
            sessionStorage.removeItem('user');
            next('login');
        } else {
            next();
        }
    }
});

router.afterEach(to => {
    // 路由匹配到后
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js